import React from 'react';
import Header from '../../../shared/SiteHeader';
import AboveTheFold from "../../../shared/AboveTheFold.js";
import tw from "twin.macro";
import Footer from "../../../shared/MiniCenteredFooter";
import Pricing from "../../../shared/Pricing";
import AudienceFit from '../../../shared/AudienceFit.js';
import DeeperTour from '../../../shared/DeeperTour.js';

const Page = tw.div`h-screen w-full relative bg-green-500`;
const Container = tw.div`-z-10 bg-green-500`;

// J-Marketing-27 / S-Marketing-21 (Q-Marketing-51 O-1, revised per
// C-Marketing-224/225, then T-Marketing-225/C-Marketing-237): the page scrolls
// the pitch's argument in order — hero claim, Act 1 solo + AI (inside
// AboveTheFold), the audience-fit matrix on the dark band (replacing "The
// Catch"), Act 3 "Your first hour with Uclusion" positioned on step 8 (Invite
// humans — that's you), collaboration evidence, pricing epilogue.
function Home() {
    return (
        <Page style={{scrollSnapType: 'y'}}>
            <Header/>
            <Container style={{scrollSnapType: 'y'}}>
                <AboveTheFold />
                <div style={{marginTop: '6rem'}}/>
                <AudienceFit />
                <DeeperTour />
                <div style={{marginTop: '4rem'}}/>
                <Pricing heading="" description="" />
                <div style={{marginTop: '5rem'}}/>
                <Footer/>
            </Container>

        </Page>
    );
}

export default Home;
